module.exports = "/images/farmaciasdelahorro.svg?374ce3a7b2ae3f85a70bec33397b7c52";